import { render, staticRenderFns } from "./DesignLogout.vue?vue&type=template&id=e71c5096&"
import script from "./DesignLogout.vue?vue&type=script&lang=js&"
export * from "./DesignLogout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports